<div class="icon">
  <img src="assets/icons/report.svg" alt="report" />
</div>
<div>
  <div class="title">{{ title() }}</div>
  <div class="sub-title">{{ subtitle() }}</div>
</div>
<ng-content />
